import script from "./project-person-purchase.vue?vue&type=script&lang=tsx&setup=true"
export * from "./project-person-purchase.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__